import React, { useEffect, useState, useContext } from "react";
import {
  createBidderOnboarding,
  updateBidderOnboarding,
  Context,
} from "services";
import {
  addMobileNumber,
  verifyMobileNumber,
  getSearchResults,
  getSearchPayload,
} from "services";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
  PickerSelectSimple,
  NavigationBase,
} from "@reusejs/react";
import { CheckIcon } from "@heroicons/react/solid";
import { setBidderMobile, clearBidderMobile } from "store";
import Logo from "../../../layouts/header/Logo";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../../layouts/Loader";
import Router from "next/router";
import { useRouter } from "next/router";
import axios from "axios";
import {
  getAllCities,
  getAllAssets,
  getCitiesbySlug,
  getAssetsbySlug,
} from "services/bidder";
import OtpModal from "./OtpModal";
import { setBidderTokens, setBidderUser, setBidderOnboarding } from "store";
export interface EventFormPorps {
  mode?: string;
  prefillData?: any;
}

export default function OnboardingForm(props: EventFormPorps) {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });

  const userOnboarding = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const router = useRouter();
  const tempMobileNumber = useSelector((state: any) => {
    return state.bidderAuth.mobile;
  });

  const [showVerify, setShowVerify] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [otp, setOtp] = useState("");
  const [refreshAssetList, setRefreshAssetList] = useState<any>();
  const [refreshCitiesList, setRefreshCitiesList] = useState<any>();
  const [modal, setModal] = useState(false);
  const [numberSent, setNumberSent] = useState(false);
  const form = useBetaForm({
    user_uuid: "",
    email: "",
    mobile: "",
    type: "",
    name: "",
    authorized_person_name: "",
    alternate_mobile: "",
    full_address: "",
    city: "",
    state: "",
    pin: "",
    pan: "",
    preferred_location: [],
    preferred_property_type: [],
    price_range: "",
    otp: "",
  });
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
  const altmobileNumberRegEx: RegExp = /^(\d{10})?$/;
  const pinRegEx: RegExp = /^[0-9]{6}$/;
  const panRegex: RegExp = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const nameRegex: RegExp = /^[a-zA-Z][a-zA-Z\s]*$/;
  const form_constraints = {
    mobile: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
        message: "^Mobile number is not valid.",
      },
      length: {
        maximum: 10,
        message: "^Mobile number is too long (maximum is 10 characters)",
      },
    },
    alternate_mobile: {
      presence: false,
      // {
      //   allowEmpty: true,
      // },
      format: {
        pattern: altmobileNumberRegEx,
        message: "^Mobile number is not valid.",
      },
      length: {
        maximum: 10,
        message: "^Mobile number is too long (maximum is 10 characters)",
      },
    },
    pin: {
      presence: {
        allowEmpty: false,
      },
      length: {
        maximum: 6,
      },
      format: {
        pattern: pinRegEx,
      },
    },
    authorized_person_name: {
      presence: {
        allowEmpty: form.getField("type").value === "individual" ? true : false,
      },
    },
    pan: {
      presence: {
        allowEmpty: false,
      },
      length: {
        maximum: 10,
      },
      format: {
        pattern: panRegex,
      },
    },
    city: {
      presence: {
        allowEmpty: false,
      },
    },
    state: {
      presence: {
        allowEmpty: false,
      },
    },
    full_address: {
      presence: {
        allowEmpty: false,
      },
    },
    name: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: nameRegex,
      },
    },
    type: {
      presence: {
        allowEmpty: false,
      },
    },
    preferred_location: {
      presence: {
        allowEmpty: false,
      },
    },
    preferred_property_type: {
      presence: {
        allowEmpty: false,
      },
    },
    price_range: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, [form?.value?.type?.value]);

  useEffect(() => {
    const emailAttribute = user.attributes.find(
      (attr: any) => attr.type === "email"
    );

    if (emailAttribute) {
      form.setField("email", emailAttribute.value);
    }

    const mobileAttribute = user.attributes.find(
      (attr: any) => attr.type === "mobile_number"
    );
    if (mobileAttribute) {
      const phonenumber = mobileAttribute.value.slice(3);
      form.setField("mobile", phonenumber);
      setIsMobileVerified(true);
    }

    if (user?.uuid) {
      form.setField("user_uuid", user?.uuid);
    }

    if (userOnboarding) {
      form.setField("type", {
        label:
          userOnboarding?.type.charAt(0).toUpperCase() +
          userOnboarding?.type.slice(1),
        value: userOnboarding?.type,
      });
      form.setField("name", userOnboarding?.name);
      form.setField(
        "authorized_person_name",
        userOnboarding?.authorized_person_name
          ? userOnboarding?.authorized_person_name
          : ""
      );
      form.setField(
        "alternate_mobile",
        userOnboarding?.alternate_mobile ? userOnboarding?.alternate_mobile : ""
      );
      form.setField("pin", userOnboarding?.pin);
      form.setField("city", userOnboarding?.city);
      form.setField("state", userOnboarding?.state);
      form.setField("full_address", userOnboarding?.full_address);
      form.setField("pan", userOnboarding?.pan);
      form.setField("price_range", {
        label:
          userOnboarding?.price_range.charAt(0).toUpperCase() +
          userOnboarding?.price_range.slice(1),
        value: userOnboarding?.price_range,
      });
      const fetchLocations = async () => {
        const location_data: any = userOnboarding?.preferred_location;
        const slugs = location_data.map((city: any) => {
          return city;
        });
        const location_prefill: any = await getCitiesbySlug(slugs);
        const locations = location_prefill.map((city: any) => {
          return {
            label: city.name,
            value: city.slug,
            uuid: city.uuid,
          };
        });
        form.setField("preferred_location", locations);
      };

      const fetchPropertyType = async () => {
        const property_data: any = userOnboarding?.preferred_property_type;
        const slugs = property_data.map((type: any) => {
          return type;
        });
        const property_prefill: any = await getAssetsbySlug(slugs);
        const property_type = property_prefill.map((asset: any) => {
          return {
            label: asset.name,
            value: asset.slug,
            uuid: asset.uuid,
          };
        });
        form.setField("preferred_property_type", property_type);
      };
      fetchLocations();
      fetchPropertyType();
    }
  }, [user]);

  const handleSubmit = async () => {
    try {
      console.log("form::>", form.value);
      if (form.validate() && isMobileVerified) {
        form.startProcessing();

        const data: any = await createBidderOnboarding(form.value);
        form.finishProcessing();
        console.log("data:::>", data);
        if (data.uuid) {
          dispatch(setBidderOnboarding(data));
          Router.replace("/");
        }
      } else if (!isMobileVerified) {
        form.pushError({ mobile: ["Mobile no. not verified"] });
        setShowVerify(false);
        setShowResend(false);
      }
    } catch (error: any) {
      form.finishProcessing();
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }
    }
  };

  const handlePincodeChange = async (val: string) => {
    form.setField("pin", val);
    if (val.length === 6) {
      axios
        .get(`https://api.postalpincode.in/pincode/${val}`)
        .then((response) => {
          if (response.data[0].Status === "Success") {
            const place = response?.data[0]?.PostOffice;

            if (place) {
              const city = place[0]["District"];
              const state = place[0]["State"];
              form.setField("city", city);
              form.setField("state", state);

              form.removeError("pin");
            } else {
              form.setField("city", "");
              form.setField("state", "");
              form.pushError({ pin: ["Enter Valid Pin"] });
            }
          } else {
            form.setField("city", "");
            form.setField("state", "");
            form.pushError({ pin: [response?.data[0]?.Message] });
          }
        })
        .catch((error) => {
          console.error("Error:", error.response);
          form.setField("city", "");
          form.setField("state", "");
        });
    } else if (val.length > 6) {
      form.setField("city", "");
      form.setField("state", "");
      form.pushError({ pin: ["PIN cannot exceed 6 digits"] });
    } else {
      form.setField("city", "");
      form.setField("state", "");
    }
  };

  const handleMobile = async (val: string) => {
    form.setField("mobile", val);
    if (val.length === 10 && mobileNumberRegEx.test(val)) {
      setShowVerify(true);
      form.removeError("mobile");
    } else {
      setShowVerify(false);
      setShowResend(false);
    }
  };

  const handleSubmitMobile = async () => {
    try {
      setNumberSent(true);

      const data: any = await addMobileNumber({
        value: form.getField("mobile"),
      });

      if (data) {
        dispatch(setBidderMobile(form.getField("mobile")));
        setModal(true);
        setShowResend(true);
        setNumberSent(false);
      }
    } catch (error: any) {
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        form.pushError({ mobile: [error.response.data.errors.value] });
      }
      setNumberSent(false);
      setModal(false);
      setShowVerify(false);
      setShowResend(false);
    }
  };

  const handleVerifyMobile = async () => {
    try {
      setNumberSent(true);
      const data: any = await verifyMobileNumber({
        otp: otp,
        value: form.getField("mobile"),
      });
      if (data) {
        form.removeError("mobile");
        dispatch(clearBidderMobile());
        setIsMobileVerified(true);
        setShowResend(false);
        setShowVerify(false);
        setNumberSent(false);
      }
    } catch (error: any) {
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        if (
          error?.response?.data?.errors?.value &&
          error?.response?.data?.errors?.value[0] === "Invalid Token"
        )
          form.pushError({ mobile: ["Invalid OTP"] });
        else form.pushError({ mobile: [error?.response?.data?.errors?.value] });
      }
      setNumberSent(false);
    }
  };

  return (
    <div className="sm: grid sm:grid-cols-2 gap-4 border border-gray-300 rounded-md shadow-md p-4">
      <NavigationBase
        left={Logo}
        backgroundClasses="bg-white fixed top-0 left-0 w-full z-10"
        widthClasses="mx-auto w-full px-8"
        leftArrangement="none"
        middleArrangement="ml-8 z-30"
        rightArrangement="flex-1 justify-end w-64"
        borderClasses="relative border-b border-gray-200"
      />
      <div className="col-span-2 border-b border-gray-400 font-semibold pb-2">
        Onboarding
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Email",
          }}
          name={"email"}
          onChange={(val) => {}}
          type={"text"}
          error={
            form.errors.get("email") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("email")[0]}
              </p>
            ) : null
          }
          value={form.getField("email")}
          disabled={true}
          htmlFor={"email"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Mobile",
          }}
          name={"mobile"}
          placeholder={"Enter Mobile No."}
          onChange={(val: any) => handleMobile(val)}
          error={
            form.errors.get("mobile") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("mobile")[0]}
              </p>
            ) : null
          }
          type={"text"}
          value={form.getField("mobile")}
          disabled={isMobileVerified}
          htmlFor={"mobile"}
        />
        {showVerify &&
          (showResend ? (
            <ButtonBase
              variant="primary"
              type="submit"
              label={"Resend"}
              onClick={() => {
                setOtp("");
                handleSubmitMobile();
              }}
              buttonBaseClasses={{
                font: "text-base text-xs",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-12",
                padding: "px-2 py-1",
              }}
              busy={numberSent}
              busyText={<Loader height="h-3" width="w-3" />}
            />
          ) : (
            <ButtonBase
              variant="primary"
              type="submit"
              label={"Verify"}
              onClick={handleSubmitMobile}
              buttonBaseClasses={{
                font: "text-base text-xs",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-12",
                padding: "px-2 py-1",
              }}
              busy={numberSent}
              busyText={<Loader height="h-3" width="w-3" />}
            />
          ))}

        {showResend && !numberSent && (
          <button
            className="mt-2 text-sm text-blue-500 ml-3"
            onClick={() => {
              setOtp("");
              setModal(true);
            }}
          >
            Re-Enter
          </button>
        )}

        {isMobileVerified && (
          <div className="h-6 w-6 rounded-full bg-green-100">
            <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
          </div>
        )}
      </div>
      <div className="">
        <PickerSelectSimple
          dataSource={(c) => {
            return [
              { label: "Individual", value: "individual" },
              { label: "Proprietors", value: "proprietors" },
              { label: "Partnership", value: "partnership" },
              { label: "Company", value: "company" },
            ];
          }}
          defaultSelected={
            form.getField("type") !== "" ? [form.getField("type")] : []
          }
          labelBaseProps={{
            label: "Type",
          }}
          onChange={(value: any) => form.setField("type", value)}
          error={
            form.errors.get("type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
        />
      </div>
      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Name",
          }}
          name={"name"}
          onChange={(val) => {
            form.setField("name", val);
          }}
          placeholder={"Enter name"}
          type={"text"}
          error={
            form.errors.get("name") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("name")[0]}
              </p>
            ) : null
          }
          value={form.getField("name")}
          htmlFor={"name"}
        />
      </div>
      {form.getField("type").value !== "individual" && (
        <div className="">
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Authorized Person Name",
            }}
            name={"authorized_person_name"}
            onChange={(val) => {
              form.setField("authorized_person_name", val);
            }}
            placeholder={"Enter authorized person name"}
            type={"text"}
            error={
              form.errors.get("authorized_person_name") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("authorized_person_name")[0]}
                </p>
              ) : null
            }
            value={form.getField("authorized_person_name")}
            htmlFor={"authorized_person_name"}
          />
        </div>
      )}
      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Alternate Mobile",
          }}
          name={"alternate_mobile"}
          onChange={(val) => {
            form.setField("alternate_mobile", val);
          }}
          placeholder={"Enter alternate mobile"}
          type={"text"}
          error={
            form.errors.get("alternate_mobile") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("alternate_mobile")[0]}
              </p>
            ) : null
          }
          value={form.getField("alternate_mobile")}
          htmlFor={"alternate_mobile"}
        />
      </div>
      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Pincode",
          }}
          name={"pin"}
          onChange={(val: any) => handlePincodeChange(val)}
          placeholder={"Enter pincode"}
          type={"text"}
          error={
            form.errors.get("pin") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("pin")[0]}
              </p>
            ) : null
          }
          value={form.getField("pin")}
          htmlFor={"pin"}
        />
      </div>
      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Full Address",
          }}
          name={"full_address"}
          onChange={(val) => {
            form.setField("full_address", val);
          }}
          placeholder={"Enter full address"}
          type={"text"}
          error={
            form.errors.get("full_address") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("full_address")[0]}
              </p>
            ) : null
          }
          value={form.getField("full_address")}
          htmlFor={"full_address"}
        />
      </div>
      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "City",
          }}
          name={"city"}
          onChange={(val) => {
            form.setField("city", val);
          }}
          placeholder={"Enter city"}
          type={"text"}
          error={
            form.errors.get("city") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("city")[0]}
              </p>
            ) : null
          }
          value={form.getField("city")}
          disabled={false}
          htmlFor={"city"}
        />
      </div>
      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "State",
          }}
          name={"state"}
          onChange={(val) => {
            form.setField("state", val);
          }}
          placeholder={"Enter state"}
          type={"text"}
          error={
            form.errors.get("state") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("state")[0]}
              </p>
            ) : null
          }
          value={form.getField("state")}
          disabled={true}
          htmlFor={"state"}
        />
      </div>

      <div className="">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "PAN",
          }}
          name={"pan"}
          onChange={(val: any) => {
            let value = val.toUpperCase();
            form.setField("pan", value);
          }}
          placeholder={"Enter pan"}
          type={"text"}
          error={
            form.errors.get("pan") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("pan")[0]}
              </p>
            ) : null
          }
          value={form.getField("pan")}
          htmlFor={"pan"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              { label: "1 to 10 Lakhs", value: "1 to 10 Lakhs" },
              { label: "10 to 50 Lakhs", value: "10 to 50 Lakhs" },
              { label: "50 Lakhs to 1 Cr", value: "50 Lakhs to 1 Cr" },
              { label: "1 Cr to 5 Cr", value: "1 Cr to 5 Cr" },
              { label: "5 Cr and Above", value: "5 Cr and Above" },
            ];
          }}
          defaultSelected={
            form.getField("price_range") !== ""
              ? [form.getField("price_range")]
              : []
          }
          labelBaseProps={{
            label: "Price Range",
          }}
          onChange={(value: any) => form.setField("price_range", value)}
          error={
            form.errors.get("price_range") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("price_range")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
        />
      </div>
      {/* /////////// PTYPE */}
      <div>
        <PickerSelectSimple
          refresh={refreshAssetList}
          dataSource={async (c) => {
            const assetsData: any = await getAllAssets(c);
            const mappeddata = assetsData.map((item: any) => {
              return {
                label: item.name,
                value: item.slug,
                uuid: item.uuid,
              };
            });
            return mappeddata;
          }}
          defaultSelected={
            form.getField("preferred_property_type").length !== 0
              ? form.getField("preferred_property_type")
              : []
          }
          labelBaseProps={{
            label: "Preferred Property Type",
          }}
          onChange={(value: any) => {
            form.setField("preferred_property_type", value);
          }}
          error={
            form.errors.get("preferred_property_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("preferred_property_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={true}
          enableClear={true}
          enableClose={false}
          enableSearch={true}
        />
      </div>
      {/* ////// PLOC */}
      <div>
        <PickerSelectSimple
          refresh={refreshCitiesList}
          dataSource={async (c) => {
            const citiesData: any = await getAllCities(c);
            const mappedData = citiesData.map((item: any) => {
              return {
                value: item.slug,
                label: item.name,
                uuid: item.uuid,
              };
            });
            return mappedData;
          }}
          defaultSelected={
            form.getField("preferred_location").length !== 0
              ? form.getField("preferred_location")
              : []
          }
          labelBaseProps={{
            label: "Preferred Location",
          }}
          onChange={async (value: any) => {
            form.setField("preferred_location", value);
          }}
          error={
            form.errors.get("preferred_location") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("preferred_location")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={true}
          enableClear={true}
          enableClose={false}
          enableSearch={true}
        />
      </div>
      {!userOnboarding && (
        <div className="col-span-2 flex justify-center pt-4">
          <ButtonBase
            variant="primary"
            type="submit"
            label={"Submit"}
            onClick={() => handleSubmit()}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-blue-600 hover:bg-blue-700",
              textColor: "text-white",
              border: "any",
              width: "w-24",
              padding: "px-4 py-2",
            }}
            busy={form.busy}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      )}

      {userOnboarding && (
        <div className="col-span-2 flex justify-center pt-4">
          <ButtonBase
            variant="primary"
            type="submit"
            label={"Close"}
            onClick={() => Router.replace("/")}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-blue-600 hover:bg-blue-700",
              textColor: "text-white",
              border: "any",
              width: "w-24",
              padding: "px-4 py-2",
            }}
            busy={form.busy}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      )}

      {modal && (
        <OtpModal
          otp={otp}
          setModal={setModal}
          setOtp={setOtp}
          callback={handleVerifyMobile}
        />
      )}
    </div>
  );
}
